import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCopy = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5026 8.08203H9.2526C8.60827 8.08203 8.08594 8.60437 8.08594 9.2487V14.4987C8.08594 15.143 8.60827 15.6654 9.2526 15.6654H14.5026C15.1469 15.6654 15.6693 15.143 15.6693 14.4987V9.2487C15.6693 8.60437 15.1469 8.08203 14.5026 8.08203Z",
			stroke: "#005AA0",
			strokeWidth: 1.7,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.16667 11.5833C4.85725 11.5833 4.5605 11.4604 4.34171 11.2416C4.12292 11.0228 4 10.7261 4 10.4167V5.16667C4 4.85725 4.12292 4.5605 4.34171 4.34171C4.5605 4.12292 4.85725 4 5.16667 4H10.4167C10.7261 4 11.0228 4.12292 11.2416 4.34171C11.4604 4.5605 11.5833 4.85725 11.5833 5.16667",
			stroke: "#005AA0",
			strokeWidth: 1.7,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgCopy);
export { ForwardRef as ReactComponent };
